<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
					<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/Packet' }">分组管理</el-breadcrumb-item>
					<el-breadcrumb-item v-else :to="{ path: '/iot/terminal' }">终端管理</el-breadcrumb-item>
					<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/PacketData',query: {id: $route.query.Packet }}">设备信息</el-breadcrumb-item>
					<el-breadcrumb-item v-else :to="{ path: '/iot/sensor',query: {id: $store.state.Iot.Aerationoperate.terminalId }}">设备信息</el-breadcrumb-item>
					<el-breadcrumb-item>操作日志</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud ref="log" :fields="fields" :select="select" :limits="limits" apiU="Aerationoperate"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'aerationStatus',
						label: '操作状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: "开启",
									value: 1
								},
								{
									label: "关闭",
									value: 2
								},
								{
									label: "正在关闭",
									value: 3
								},
								{
									label: "正在开启",
									value: 4
								},
								{
									label: "故障",
									value: 5
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'aerationType',
						label: '操作类型',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: "按键或自动操作",
									value: 1
								},
								{
									label: "手动操作",
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'aerationResult',
						label: '操作结果',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: "成功",
									value: 1
								},
								{
									label: "失败",
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '操作时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [
					{
						name: 'aerationStatus',
						label: '操作状态',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '开启',
									value: 1
								},
								{
									label: '关闭',
									value: 2
								}
							]
						}
					},
					{
						name: 'aerationType',
						label: '操作类型',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '按键或自动操作',
									value: 1
								},
								{
									label: 'PC操作',
									value: 2
								}
							]
						}
					},
					{
						name: 'aerationResult',
						label: '操作结果',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '成功',
									value: 1
								},
								{
									label: '失败',
									value: 2
								}
							]
						}
					}
				],
				limits: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: false,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
